import {SortField, Tag, useDeleteTag, useTags} from "@/hooks/useTags.ts";
import HeaderTextButton from "@/components/HeaderTextButton.tsx";
import {useQueryModal} from "@/hooks/useQueryModal.ts";
import {useTableQuery} from "@/hooks/useTableQuery.ts";
import {useMemo} from "react";
import TagTable from "@/features/tags/components/TagTable.tsx";
import TagUpsertDialog from "@/features/tags/components/TagUpsertDialog.tsx";

export default function AdminTagsPage() {
    const {
        searchParams,
        editId,
        isNew,
        modalOpen,
        setParam,
        openCreate,
        openEdit,
        closeModal,
    } = useQueryModal();

    const {
        page,
        size,
        sortBy,
        sortOrder,
        setPage,
        onRequestSort,
    } = useTableQuery<SortField>({
        searchParams,
        setParam,
        defaultPage: 0,
        defaultSize: 10,
        defaultSortBy: "name",
        defaultSortOrder: "desc",
    });

    const {
        data: result = {page, size, total: 0, items: []} as any,
        isLoading,
        isError
    } = useTags({page, size, sortBy, sortOrder});

    const {mutateAsync: deleteTag} = useDeleteTag();

    const initialForDialog: Partial<Tag> | null = useMemo(() => {
        if (isNew) return null;
        if (editId) return result.items.find((c: Tag) => c.id === editId) ?? null;
        return null;
    }, [isNew, editId, result]);

    return (
        <>
            <HeaderTextButton
                title="Tags"
                description="Manage news tags."
                label="Add Tag"
                onClick={openCreate}
            />

            <TagTable
                content={result}
                isLoading={isLoading}
                isError={isError}
                onCreate={openCreate}
                onEdit={openEdit}
                onDelete={deleteTag}
                setPage={setPage}
                sortBy={sortBy}
                sortOrder={sortOrder}
                onRequestSort={onRequestSort}
            />

            <TagUpsertDialog
                open={modalOpen}
                initial={initialForDialog}
                onClose={closeModal}
            />
        </>
    );
}
